import React from 'react';

const HomeStyles = () => (
  <style>{`

/* === Base estable para toda la app (iOS + Android safe) === */
html,
body,
#root {
  height: 100%;
  min-height: 100%;
  margin: 0;
  padding: 0;

  /* Fondo global consistente (evita franjas cortadas) */
  background-color: #30005F;

  /* Scroll nativo correcto */
  overflow-x: hidden;
  overflow-y: auto;

  /* Evita scroll chaining raro en mobile */
  overscroll-behavior-y: auto;

  /* Previene re-anclajes molestos al cambiar altura */
  overflow-anchor: none;

  /* iOS momentum scroll */
  -webkit-overflow-scrolling: touch;
}

/* El root NO pinta “plano”: lo hace la capa ::before */
 {
  background: transparent !important;
}

/* Capa base violeta + halo dorado (detrás de la rueda) */
#homeRoot::before {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: -4;

  /* Violeta profundo + brillo suave, estilo Welcome */
  background:
    radial-gradient(circle at 50% 18%, rgba(255,215,0,0.10) 0%, rgba(255,215,0,0.00) 58%),
    radial-gradient(circle at 50% 42%, rgba(155,48,255,0.18) 0%, rgba(155,48,255,0.00) 62%),
    radial-gradient(circle at 50% 20%, #4B0082 0%, #30005F 46%, #1A0039 82%);
}

  #homeRoot {
    min-height: 100dvh;              /* permite que scrollee el body */
    overscroll-behavior-y: auto;     /* no contener para no bloquear PTR */
    overflow-anchor: none;           /* desactiva re-anclaje */
    -webkit-overflow-scrolling: touch; /* scroll suave iOS */
    scroll-padding-bottom: max(12vh, 96px);
  }

/* Evitar re-anclajes en contenedores que cambian de alto durante el scroll */
#homeRoot .welcome-card,
#homeRoot .lb-grid,
#homeRoot .lb-item,
#homeRoot [data-accordion],
#homeRoot [data-dynamic-height] {
  overflow-anchor: none;
}

@media (max-width: 600px) {
  #homeRoot {
    min-height: 100dvh;
  }
  #homeRoot .welcome-card {
    margin-top: 0 !important;
  }
}

        /* === Home: mismo estilo que Welcome === */
        @keyframes wheel-spin {
          from { transform: translate(-50%, -50%) rotate(0deg); }
          to   { transform: translate(-50%, -50%) rotate(360deg); }
        }

        /* Rueda limpia, sin fondo cuadrado, centrada y girando lento */
        /* Rueda limpia, centrada, girando lento, con leve aumento de tamaño */
#homeRoot .wheel {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 102svmin;
  height: 102svmin;
  border-radius: 50%;
  overflow: hidden;
  z-index: -1;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain; /* mantiene bordes nítidos sin cortar */
  image-rendering: -webkit-optimize-contrast;
  filter: brightness(1.08) contrast(1.12) saturate(1.1);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.12);
  animation: wheel-spin 220s linear infinite;
  transform: translate(-50%, -50%) translateZ(0);
  will-change: transform;
  backface-visibility: hidden;
  transform-origin: center center;
}

@media (min-width: 1024px) {
  #homeRoot .wheel {
    width: 102svmin;
    height: 102svmin;
  }
}

        /* Blur de soporte que rellena sobrantes, sin tapar la rueda */
        /* #homeRoot::after {
          content: "";
          position: fixed;
          inset: -10%;
          z-index: -3;
          pointer-events: none;
          background-image: url("/logo/Zodiacus.jpeg");
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 100% auto;
          background-color: rgba(48, 0, 88, 0.03);
          background-blend-mode: screen;
          filter: blur(2px) saturate(1.06) brightness(1.06) contrast(1.02);
          transform: translateZ(0);
          backface-visibility: hidden;
          -webkit-mask-image: radial-gradient(62% 62% at 50% 50%, #000 70%, rgba(0,0,0,0) 100%);
          mask-image: radial-gradient(62% 62% at 50% 50%, #000 70%, rgba(0,0,0,0) 100%);
        } */

        @media (prefers-reduced-motion: reduce) {
          #homeRoot .wheel { animation: none; }
        }
        /* Permitir giro lento aunque el SO pida menos movimiento, sólo si el contenedor lo autoriza */
        @media (prefers-reduced-motion: reduce) {
          #homeRoot[data-allow-motion="1"] .wheel { animation: wheel-spin 220s linear infinite; }
        }

/* Estabilidad extra de scroll en mobile: gestos solo verticales */
#homeRoot { touch-action: pan-y; }

#homeRoot .scroll-tail {
  height: max(12vh, 96px);
  pointer-events: none;
}

/* === Foro bell: anclada SIEMPRE en el “corte” entre el header (píldora) y los botones === */
#homeRoot .forum-bell-anchor {
  position: relative;
  width: 100%;
  height: 0;                 /* no empuja layout */
  margin: 12px 0;            /* separa header y botones */
  overflow: visible;
}
#homeRoot .forum-bell-fab {
  position: absolute;
  right: -6px;               /* queda “entre” contenedores, sin pisar la píldora */
  top: 0;
  transform: translateY(-50%);
  z-index: 50;
}
@media (max-width: 420px) {
  #homeRoot .forum-bell-fab { right: -4px; }
}

        /* === Aurora background (sutil detrás de la rueda) === */
        /* @keyframes auroraFlow {
          0%   { transform: translate(-55%, -52%) rotate(0deg) scale(1.05); filter: blur(42px) saturate(1.05) brightness(1.02); }
          50%  { transform: translate(-45%, -48%) rotate(10deg) scale(1.07); filter: blur(46px) saturate(1.08) brightness(1.06); }
          100% { transform: translate(-55%, -52%) rotate(0deg) scale(1.05); filter: blur(42px) saturate(1.05) brightness(1.02); }
        }
        #homeRoot::before {
          content: "";
          position: fixed;
          top: 50%;
          left: 50%;
          width: 130vmax;
          height: 130vmax;
          transform: translate(-50%, -50%) translateZ(0);
          z-index: -2;
          pointer-events: none;
          background:
            radial-gradient(40% 40% at 50% 50%, rgba(255,215,0,0.18) 0%, rgba(155,48,255,0.10) 45%, rgba(0,0,0,0) 70%),
            conic-gradient(from 180deg at 50% 50%, rgba(155,48,255,0.14), rgba(255,215,0,0.14), rgba(155,48,255,0.14));
          mix-blend-mode: screen;
          opacity: 0.38;                  /* más claro */
          animation: auroraFlow 46s ease-in-out infinite;
          will-change: opacity;
          backface-visibility: hidden;
        }
        @media (prefers-reduced-motion: reduce) {
          #homeRoot::before { animation: none; }
        } */

/* === Card de bienvenida: entrada suave === */
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}
        #homeRoot .welcome-card {
  animation: fadeInUp 420ms cubic-bezier(.2,.8,.2,1) both;
  will-change: transform, opacity;
  max-width: 86%;                /* más compacta */
  width: min(500px, 86vw);        /* ✅ ancho estable: evita que dependa del contenido (y que la campana se corra) */
  box-sizing: border-box;
  margin: 6px auto 14px auto;
  padding: 12px 14px;
  border-radius: 12px;

  /* Cristal dorado más luminoso y menos opaco */
  background: linear-gradient(
  135deg,
  rgba(255, 215, 0, 0.035),
  rgba(255, 255, 255, 0.055)
);
  /* Ensure no blur or overlay: */
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  filter: none !important;
  border: 1px solid rgba(255, 215, 0, 0.28);
  box-shadow:
    0 2px 6px rgba(0,0,0,0.06),
    inset 0 0 0 1px rgba(255,255,255,0.08);
  color: #fffdf6;
  transition: box-shadow .25s ease, transform .2s ease, background .2s ease;
  /* evita que la card oscurezca el fondo y elimina halos en el borde */
  mix-blend-mode: normal;
  background-clip: padding-box;
  transition: box-shadow .25s ease, transform .2s ease;
}
@media (min-width: 768px) {
  #homeRoot .welcome-card {
    max-width: 500px;            /* elegante en desktop */
    width: min(500px, 86vw);
    padding: 14px 16px;
    border-radius: 12px;
  }
}

/* === Título con brillo sutil === */
@keyframes textShine {
  0%   { background-position: -120% 0; }
  100% { background-position: 220% 0; }
}
#homeRoot .welcome-title {
  background-image: linear-gradient(135deg, #FFE34D 0%, #FFC400 45%, #FFF176 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 1px 0 rgba(0,0,0,0.35), 0 0 8px rgba(255,215,0,0.35);
  letter-spacing: 0.3px;
  background-size: 180% 100%;
  animation: textShine 3.4s linear infinite;
}
@media (prefers-reduced-motion: reduce) {
  #homeRoot .welcome-title { animation: none; }
}

        /* Botones: accesibilidad de foco visible */
        #homeRoot .btn:focus-visible {
          outline: 3px solid rgba(218,165,32,0.55);
          outline-offset: 2px;
        }

        /* Botón "Sala de ruletas" */
/* Botón "Sala de ruletas" */
.btn-roulette-violet {
  background: linear-gradient(135deg, rgba(106,13,173,0.46), rgba(75,0,130,0.46)) !important; /* violeta translúcido */
  border: 1.5px solid rgba(218,165,32,0.60) !important;  /* borde dorado visible */
  color: #FFE98A !important;
  font-weight: 800;
  border-radius: 15px;
  width: 100%;
  padding: 14px 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 0 14px rgba(106, 13, 173, 0.45);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  transition: background 0.25s ease, border-color 0.25s ease, transform 0.2s ease, box-shadow 0.25s ease;
}

/* 🔥 Hover violeta — mantener violeta translúcido */
.btn-roulette-violet:hover,
.btn-roulette-violet:focus {
  background: linear-gradient(135deg, rgba(123,31,214,0.66), rgba(75,0,130,0.66)) !important; /* un tono más brillante al hover */
  border-color: rgba(218,165,32,0.80) !important;
  transform: translateY(-2px);
  box-shadow: 0 0 18px rgba(123, 31, 214, 0.60);
}

/* Activo (click) — más profundo */
.btn-roulette-violet:active {
  transform: translateY(0);
  background: linear-gradient(135deg, rgba(94,11,175,0.56), rgba(60,0,108,0.56)) !important;
  box-shadow: 0 0 10px rgba(62, 0, 108, 0.45);
}

.emoji-badge-gold {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #DAA520;
  background: rgba(0,0,0,0.15);
  overflow: hidden;
  line-height: 1;
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* 🔑 EL FIX REAL ESTÁ ACÁ */
.emoji-badge-gold span {
  display: block;
  font-size: 16px;          /* ⬅️ más chico que antes */
  line-height: 1;
  transform: scale(0.9);    /* ⬅️ mete el emoji dentro */
}

.emoji-badge-gold .emoji-inner{
  display: block;
  line-height: 1;
  font-size: 16px;                 /* ⬅️ antes 18 */
  transform: translateY(0.2px) scale(0.86); /* ⬅️ más adentro */
  transform-origin: center;
  font-family: "Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",system-ui,sans-serif;
}

        /* === Leaderboard: estilos mejorados === */
        /* === Medalla (badge) con animación y glow sutil === */
        @keyframes medal-pulse {
          0%   { box-shadow: 0 2px 8px rgba(218,165,32,0.18), 0 0 0 0 rgba(218,165,32,0.25); transform: translateY(0); }
          50%  { box-shadow: 0 6px 16px rgba(218,165,32,0.30), 0 0 18px 4px rgba(255,215,0,0.18); transform: translateY(-1px); }
          100% { box-shadow: 0 2px 8px rgba(218,165,32,0.18), 0 0 0 0 rgba(218,165,32,0.25); transform: translateY(0); }
        }
        @keyframes medal-shimmer {
  0%   { background-position: -120% 0; }
  100% { background-position: 220% 0; }
}

        /* === Trivia Stats Accordion: sin blur ni oscurecer la rueda === */
        #homeRoot [data-accordion],
        #homeRoot .trivia-accordion,
        #homeRoot .stats-panel,
        #homeRoot .lb-grid,
        #homeRoot .lb-item {

          filter: none !important;
          mix-blend-mode: normal !important;         /* nunca oscurece el fondo */
        }

        /* Smooth, jank-free accordion (no blur, no overlay) */
#homeRoot [data-accordion] {
  overflow: hidden; /* evita empujones mientras anima */
  max-height: 0;   /* colapsado por defecto */
  transition: max-height 260ms cubic-bezier(.2,.8,.2,1);
  will-change: max-height;
  contain: layout style; /* reduce reflow alrededor en mobile */
  backface-visibility: hidden;
}
#homeRoot [data-accordion][data-open="1"] {
  /* abierto: el JS setea max-height dinámicamente */
}
@media (prefers-reduced-motion: reduce) {
  #homeRoot [data-accordion] { transition: none; }
}

        /* Fondo ultraligero y bordes suaves para el acordeón */
        #homeRoot [data-accordion],
        #homeRoot .trivia-accordion,
        #homeRoot .stats-panel {
          background: linear-gradient(180deg, rgba(255,255,255,.02), rgba(255,255,255,.035)) !important;
          box-shadow: 0 6px 18px rgba(0,0,0,.08) !important; /* sin halos oscuros */
          border: 1px solid rgba(218,165,32,.28) !important;
        }

        /* Cualquier pseudo-elemento que agregue velos/vidrios en el acordeón queda deshabilitado */
        #homeRoot [data-accordion]::before,
        #homeRoot [data-accordion]::after,
        #homeRoot .trivia-accordion::before,
        #homeRoot .trivia-accordion::after,
        #homeRoot .stats-panel::before,
        #homeRoot .stats-panel::after {
          display: none !important;
          content: none !important;
        }

        #homeRoot .medal-badge {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          padding: 2px 8px;
          border-radius: 999px;
          border: 1px solid rgba(218,165,32,0.5);
          font-weight: 900;
          font-size: 10px;
          color: #3a0c6e;
          animation: medal-pulse 2.8s ease-in-out infinite;
          will-change: transform, box-shadow;
          backdrop-filter: blur(2px) saturate(1.02);
          -webkit-backdrop-filter: blur(2px) saturate(1.02);
          /* 🔑 clave: que se adapte al contenido sin recortarlo */
          white-space: nowrap;
          flex-shrink: 0;
          overflow: visible;
        }
        /* Capa brillo diagonal animada */
        #homeRoot .medal-badge::after {
          content: "";
          position: absolute;
          inset: 0;
          background-image: linear-gradient(120deg,
            rgba(255,255,255,0) 0%,
            rgba(255,255,255,0.28) 45%,
            rgba(255,255,255,0.28) 55%,
            rgba(255,255,255,0) 100%);
          background-size: 180% 100%;
          background-repeat: no-repeat;
          animation: medal-shimmer 3.2s linear infinite;
          pointer-events: none;
        }
        /* Intensidad por nivel */
        #homeRoot .medal-legend { animation-duration: 2.2s; }
        #homeRoot .medal-champion { animation-duration: 2.4s; }
        #homeRoot .medal-elite { animation-duration: 2.6s; }
        #homeRoot .medal-gold { animation-duration: 2.8s; }
        #homeRoot .medal-silver { animation-duration: 3.0s; }
        #homeRoot .medal-bronze { animation-duration: 3.2s; }
        /* Respeta preferencias de reducir movimiento */
        @media (prefers-reduced-motion: reduce) {
          #homeRoot .medal-badge,
          #homeRoot .medal-badge::after {
            animation: none !important;
          }
        }
        /* =========================================================
           LEADERBOARD (Ranking) — premium + legible
           - Nombres súper legibles (blanco cálido + sombra)
           - Puntaje en pill dorada (alto contraste)
           - Hover elegante (sin “flash” dorado total)
           ========================================================= */
#homeRoot .lb-grid {
  display: grid;
  gap: 10px;
  justify-content: center;
  margin-top: 8px;
}

#homeRoot .lb-item {
  display: grid;
  grid-template-columns: 34px 1fr 72px; /* rank | nombre | score */
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 14px;
  min-width: 260px;
  min-height: 50px;

  /* glass violeta (sin blur para evitar bugs) */
  background: linear-gradient(135deg, rgba(92, 15, 160, 0.78), rgba(52, 0, 105, 0.62));
  border: 1px solid rgba(218, 165, 32, 0.42);
  box-shadow:
    0 10px 22px rgba(0,0,0,0.14),
    inset 0 0 0 1px rgba(255,255,255,0.06);

  /* IMPORTANTE: el texto base NO va negro */
  color: rgba(255, 253, 246, 0.92);
  font-weight: 850;
  font-size: 0.92rem;

  transition: transform .16s ease, box-shadow .18s ease, border-color .18s ease, filter .18s ease;
  transform: translateZ(0);
  backface-visibility: hidden;
}

#homeRoot .lb-item:hover {
  transform: translateY(-1px);
  border-color: rgba(218,165,32,0.62);
  box-shadow:
    0 14px 30px rgba(0,0,0,0.18),
    inset 0 0 0 1px rgba(255,255,255,0.08);
  filter: saturate(1.06) brightness(1.03);
}

/* Rank: badge dorado con borde */
#homeRoot .lb-rank {
  text-align: center;
  font-weight: 950;
  color: #2a0a4d;
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: linear-gradient(135deg, rgba(218,165,32,0.92), rgba(255,215,0,0.72));
  border: 1px solid rgba(255,215,0,0.65);
  box-shadow: 0 6px 14px rgba(218,165,32,0.18);
}

/* Contenedor del nombre: permite shrink + ellipsis */
#homeRoot .lb-name {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;      /* CLAVE: deja que el 1fr se encoja */
  overflow: hidden;  /* habilita ellipsis */
}

/* Avatar / crown no shrink */
#homeRoot .lb-name img,
#homeRoot .lb-name .lb-crown {
  flex-shrink: 0;
}

#homeRoot .lb-name img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(255,215,0,0.40);
  box-shadow: 0 6px 14px rgba(0,0,0,0.16);
}

/* Texto del nombre: blanco cálido + sombra para legibilidad */
#homeRoot .lb-name > :last-child {
  display: block;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba(255, 253, 246, 0.96);
  text-shadow: 0 1px 0 rgba(0,0,0,0.42);
  letter-spacing: 0.15px;
}

/* Puntaje: pill dorada premium (alto contraste) */
#homeRoot .lb-score {
  text-align: right;
  font-weight: 950;
}

#homeRoot .lb-score .score-pill,
#homeRoot .lb-item .score-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 54px;
  padding: 6px 10px;
  border-radius: 999px;
  background: linear-gradient(135deg, rgba(218,165,32,0.98), rgba(255,215,0,0.78));
  border: 1px solid rgba(255,215,0,0.62);
  color: #2a0a4d;
  box-shadow: 0 10px 22px rgba(218,165,32,0.16);
  text-shadow: none;
}

/* Podio: TOP 1 ultra premium */
#homeRoot .lb-item.top1 {
  background: linear-gradient(135deg, rgba(218,165,32,0.50), rgba(75,0,130,0.52));
  border: 1px solid rgba(255,215,0,0.70);
  box-shadow:
    0 16px 34px rgba(0,0,0,0.20),
    0 0 18px rgba(255,215,0,0.12),
    inset 0 0 0 1px rgba(255,255,255,0.10);
}

#homeRoot .lb-item.top1 .lb-name > :last-child {
  color: #fffdf6;
  text-shadow: 0 1px 0 rgba(0,0,0,0.50);
}

/* Resaltar "yo" sin chocar con podio */
#homeRoot .lb-item.me {
  outline: 2px solid rgba(255,215,0,0.52);
  outline-offset: 2px;
}

@media (max-width: 480px) {
  #homeRoot .lb-item { grid-template-columns: 32px 1fr 66px; padding: 9px 10px; }
  #homeRoot .lb-name img { width: 28px; height: 28px; }
  #homeRoot .lb-score .score-pill, #homeRoot .lb-item .score-pill { min-width: 50px; padding: 5px 9px; }
}

        /* Avatar y coronita no se encogen ni rompen línea */
        #homeRoot .lb-name img,
        #homeRoot .lb-name .lb-crown {
          flex-shrink: 0;
        }

        /* El texto del nombre ocupa el resto y hace elipsis si no entra */
        #homeRoot .lb-name > :last-child {
          display: block;
          min-width: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        #homeRoot .lb-name img {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          object-fit: cover;
          border: 1px solid rgba(75,0,130,0.18);
        }

        #homeRoot .lb-score { text-align: right; }

        #homeRoot .score-pill {
          display: inline-block;
          padding: 4px 10px;
          border-radius: 999px;
          background: rgba(75,0,130,0.08);
          border: 1px solid rgba(75,0,130,0.18);
          font-weight: 900;
        }

        #homeRoot .lb-crown { filter: drop-shadow(0 1px 2px rgba(0,0,0,.25)); }

        /* === Trivia: estilos mejorados para respuestas === */
        #homeRoot .trivia-answer {
          text-align: left;
          padding: 12px 14px;
          border-radius: 12px;
          border: 1px solid rgba(0,0,0,0.05);
          background: rgba(255,255,255,0.66);
          color: #2c1c4e;
          font-weight: 800;
          backdrop-filter: blur(4px);
          -webkit-backdrop-filter: blur(4px);
          transition: transform .06s ease, box-shadow .1s ease, background .15s ease, border-color .15s ease;
        }
        #homeRoot .trivia-answer:hover { transform: translateY(-1px); box-shadow: 0 8px 16px rgba(0,0,0,.08); }
        #homeRoot .trivia-answer.state-correct { background: rgba(34,197,94,0.2); border-color: rgba(34,197,94,0.35); color: #073b18; }
        #homeRoot .trivia-answer.state-wrong { background: rgba(255,82,82,0.18); border-color: rgba(255,82,82,0.35); }
        #homeRoot .trivia-answer:disabled { opacity: .9; cursor: default; }
      /* === Trivia modal: responsive === */
#homeRoot .trivia-modal {
  max-height: 85vh;
  transform: translateZ(0);
  backface-visibility: hidden;
  will-change: transform, opacity;
}
#homeRoot .trivia-modal .modal-header {
  position: sticky; top: 0; z-index: 2;
}

/* Altura y compactación del ranking */
#homeRoot .trivia-modal .lb-grid {
  max-height: min(52vh, 320px) !important;
  overflow-y: auto; padding-right: 4px; scrollbar-width: thin;
}

/* Compactar ítems del ranking */
#homeRoot .trivia-modal .lb-item {
  grid-template-columns: minmax(28px, max-content) minmax(0, 1fr) max-content;
  gap: 8px; padding: 8px 10px; font-size: 0.9rem;
}
#homeRoot .trivia-modal .lb-name img { width: 26px; height: 26px; }
#homeRoot .trivia-modal .score-pill { padding: 4px 9px; white-space: nowrap; }
#homeRoot .trivia-modal button:focus-visible { outline: 3px solid rgba(255,215,0,.78); outline-offset: 3px; }

/* ——— Mobile ——— */
@media (max-width: 480px) {
  #homeRoot .trivia-modal {
    top: 6% !important;
    left: 50%; transform: translate(-50%, 0) !important;
    width: 94vw !important; max-height: 82vh !important; border-radius: 14px !important;
  }
  #homeRoot .trivia-modal .lb-grid {
    max-height: 40vh !important;  /* ↓ más bajo en celu */
  }
  #homeRoot .trivia-modal .lb-item {
    grid-template-columns: minmax(24px, max-content) minmax(0, 1fr) max-content;
    gap: 6px; padding: 6px 8px; font-size: 0.88rem;
  }
  #homeRoot .trivia-modal .lb-name img { width: 22px; height: 22px; }
  #homeRoot .trivia-modal .score-pill { padding: 3px 8px; font-weight: 900; }

  /* === Trivia Floating Button: fijar tamaño y aislar composición para que no empuje el scroll === */
#homeRoot .trivia-fab {
  position: fixed;
  right: 18px;
  bottom: max(18px, env(safe-area-inset-bottom));
  z-index: 9999;
  border-radius: 999px;
  padding: 12px 16px;
  font-weight: 900;
  background: var(--fab-bg, linear-gradient(135deg,#DAA520,#f4c84a));
  color: var(--fab-fg, #4B0082);
  border: none;
  box-shadow: 0 10px 24px rgba(218,165,32,.35);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  /* 🔒 Estabilidad visual */
  height: 46px;          /* altura fija */
  min-width: 124px;      /* ancho mínimo estable */
  line-height: 1;        /* evita crecer por tipografía */
  white-space: nowrap;   /* evita salto de línea */

  /* 🔒 Aislar de layout/repaint global */
  contain: layout paint;
  transform: translateZ(0);
  will-change: transform;
  backface-visibility: hidden;
}

#homeRoot .trivia-fab:focus-visible {
  outline: 3px solid rgba(218,165,32,0.45);
  outline-offset: 2px;
}

/* Hover sólo donde existe hover real (no en táctiles) */
@media (hover: hover) {
  #homeRoot .trivia-fab:hover { filter: brightness(1.04) saturate(1.02); }
}

/* Badge absoluto: no altera el tamaño del botón */
#homeRoot .trivia-fab { position: fixed; } /* reafirma fixed */
  #homeRoot .trivia-fab .fab-badge {
    position: absolute;
    right: 6px;
    top: -8px;
    background: #4B0082;
    color: #FFD700;
    padding: 2px 6px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 800;
    pointer-events: none;
  }
}

/* === Zodiac Clash Floating Button (left side) === */
#homeRoot .clash-fab {
  position: fixed;
  left: 18px;
  bottom: max(18px, env(safe-area-inset-bottom));
  z-index: 9999;

  border-radius: 999px;
  padding: 12px 16px;
  font-weight: 900;

  height: 46px;
  min-width: 140px;
  line-height: 1;
  white-space: nowrap;

  background: linear-gradient(135deg, rgba(75,0,130,0.92), rgba(106,13,173,0.82));
  color: #FFD700;
  border: 1px solid rgba(218,165,32,0.68);
  box-shadow: 0 10px 24px rgba(0,0,0,0.22), 0 0 18px rgba(218,165,32,0.18);

  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  /* Aislar repaints */
  contain: layout paint;
  transform: translateZ(0);
  will-change: transform, filter;
  backface-visibility: hidden;

  /* Para el brillo */
  isolation: isolate;
  overflow: visible;
}

/* ✨ Glow premium (tipo medals) para Zodiac Clash */
@keyframes clashGlowPulse {
  0%   { opacity: .35; transform: scale(0.985); filter: blur(8px) saturate(1.00); }
  50%  { opacity: .85; transform: scale(1.02);  filter: blur(10px) saturate(1.12); }
  100% { opacity: .35; transform: scale(0.985); filter: blur(8px) saturate(1.00); }
}

#homeRoot .clash-fab::before {
  content: "";
  position: absolute;
  inset: -6px;
  border-radius: 999px;
  z-index: -1;
  pointer-events: none;
  background:
    radial-gradient(70% 140% at 20% 50%, rgba(255,215,0,0.48), rgba(255,215,0,0) 70%),
    radial-gradient(80% 160% at 80% 50%, rgba(218,165,32,0.42), rgba(255,215,0,0) 72%),
    radial-gradient(120% 120% at 50% 50%, rgba(106,13,173,0.26), rgba(106,13,173,0) 70%);
  animation: clashGlowPulse 1.8s ease-in-out infinite;
}

/* Intensificar en hover real */
@media (hover: hover) {
  #homeRoot .clash-fab:hover::before {
    opacity: .95;
    animation-duration: 1.35s;
  }
}

/* En tap/active: feedback táctil sin “salto” */
#homeRoot .clash-fab:active::before {
  opacity: .70;
  animation-duration: 1.6s;
}

@media (prefers-reduced-motion: reduce) {
  #homeRoot .clash-fab::before {
    animation: none !important;
    opacity: .55;
  }
}

#homeRoot .clash-fab:focus-visible {
  outline: 3px solid rgba(218,165,32,0.55);
  outline-offset: 2px;
}

@media (hover: hover) {
  #homeRoot .clash-fab:hover {
    filter: brightness(1.06) saturate(1.06);
    transform: translateY(-1px);
  }
}

#homeRoot .clash-fab:active {
  transform: translateY(0);
  filter: brightness(1.02);
}

/* Badge absoluto: no altera el tamaño del botón ni tapa el texto */
#homeRoot .clash-fab .clash-badge {
  position: absolute;
  right: 8px;
  top: -8px;
  background: #FFD700;
  color: #4B0082;
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 900;
  border: 1px solid rgba(75,0,130,0.35);
  box-shadow: 0 8px 18px rgba(0,0,0,0.18);
  pointer-events: none;
}

@media (max-width: 380px) {
  #homeRoot .clash-fab { left: 12px; min-width: 132px; }
}

/* Quitar pseudo-elementos que agregan velos oscuros */
#homeRoot [data-accordion]::before,
#homeRoot [data-accordion]::after,
#homeRoot .trivia-accordion::before,
#homeRoot .trivia-accordion::after,
#homeRoot .stats-panel::before,
#homeRoot .stats-panel::after {
  content: none !important;
  display: none !important;

}

#ptr-loader {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-100%);
  background: rgba(75, 0, 130, 0.85);
  backdrop-filter: blur(8px);
  color: #daa520;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  text-align: center;
  padding: 10px 20px;
  border-radius: 0 0 12px 12px;
  transition: transform 0.4s ease, opacity 0.3s ease;
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 10px;
  opacity: 0;
}

#ptr-loader.visible {#homeRoot
  transform: translateX(-50%) translateY(0);
  opacity: 1;
}

#ptr-loader .ptr-circle {
  width: 18px;
  height: 18px;
  border: 2px solid #daa520;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes pulseFlag {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.08); opacity: 0.95; }
}

#homeRoot .horo-card {
  position: relative;
  margin: 8px auto 0;
  max-width: 420px;
  width: calc(100% - 20px);
  color: #FFE9A6;
  border-radius: 14px;
  padding: 6px 8px;
  overflow: hidden;
  isolation: isolate;
  transform: translateZ(0);
  will-change: transform;
  backface-visibility: hidden;
  perspective: 900px;
  background: linear-gradient(135deg, rgba(75,0,130,0.18), rgba(25,0,60,0.18));
  border: 1px solid rgba(218,165,32,0.24);
  box-shadow:
    0 6px 14px rgba(0,0,0,0.16),
    inset 0 0 0 1px rgba(255,255,255,0.03);
  backdrop-filter: blur(6px) saturate(1.02);
  -webkit-backdrop-filter: blur(6px) saturate(1.02);
  transition: transform .14s ease, box-shadow .16s ease, border-color .16s ease, background .16s ease;
}

/* Outer animated aura ring */
@keyframes horoAuraSpin {
  0%   { transform: rotate(0deg);   opacity: .55; }
  50%  { opacity: .85; }
  100% { transform: rotate(360deg); opacity: .55; }
}

@keyframes horoShineSweep {
  0%   { transform: translateX(-140%) rotate(12deg); opacity: 0; }
  18%  { opacity: .75; }
  40%  { opacity: .30; }
  100% { transform: translateX(140%) rotate(12deg); opacity: 0; }
}

@keyframes horoPulse {
  0%   { filter: saturate(1.0) brightness(1.00); }
  50%  { filter: saturate(1.10) brightness(1.03); }
  100% { filter: saturate(1.0) brightness(1.00); }
}

@keyframes horoOrbDrift {
  0%   { transform: translate3d(-10px, 10px, 0) scale(.98); opacity: .38; }
  50%  { transform: translate3d(14px, -12px, 0) scale(1.06); opacity: .72; }
  100% { transform: translate3d(-10px, 10px, 0) scale(.98); opacity: .38; }
}

#homeRoot .horo-card:hover {
  transform: translateY(-1px);
  border-color: rgba(218,165,32,0.50);
  box-shadow:
    0 12px 24px rgba(0,0,0,0.28),
    inset 0 0 0 1px rgba(255,255,255,0.05);
}

/* Animated conic ring (sits behind content) */
#homeRoot .horo-card .horo-ring {
  position: absolute;
  inset: -14px;
  border-radius: 26px;
  z-index: 0;
  pointer-events: none;
  background:
    conic-gradient(from 0deg,
      rgba(255,215,0,0.00),
      rgba(255,215,0,0.45),
      rgba(106,13,173,0.40),
      rgba(255,215,0,0.55),
      rgba(255,215,0,0.00));
  filter: blur(12px);
  opacity: .24;
  animation: horoAuraSpin 7.5s linear infinite;
}

/* Premium shimmer sweep */
#homeRoot .horo-card .horo-shine {
  position: absolute;
  top: -40%;
  left: -60%;
  width: 60%;
  height: 180%;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.22) 45%, rgba(255,255,255,0) 100%);
  transform: rotate(12deg);
  mix-blend-mode: screen;
  opacity: 0;
  animation: horoShineSweep 6.2s ease-in-out infinite;
}

/* Floating orb accents */
#homeRoot .horo-card .horo-orb {
  position: absolute;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
  background: radial-gradient(circle at 30% 30%, rgba(255,215,0,0.38), rgba(218,165,32,0.16) 40%, rgba(106,13,173,0.10) 68%, rgba(0,0,0,0) 72%);
  filter: blur(1px);
  animation: horoOrbDrift 3.6s ease-in-out infinite;
}
#homeRoot .horo-card .horo-orb.orb-a { left: -26px; bottom: -34px; animation-duration: 4.2s; }
#homeRoot .horo-card .horo-orb.orb-b { right: -28px; top: -30px;  animation-duration: 5.0s; opacity: .18; }

/* Content stacking: keep above effects */
#homeRoot .horo-head,
#homeRoot .horo-body,
#homeRoot .horo-footer {
  position: relative;
  z-index: 2;
}

/* Headline: subtle animated glow */
#homeRoot .horo-title {
  animation: horoPulse 3.2s ease-in-out infinite;
}

/* Button: animated golden sheen */
@keyframes horoBtnSheen {
  0%   { transform: translateX(-120%) skewX(-16deg); opacity: 0; }
  18%  { opacity: .55; }
  40%  { opacity: .12; }
  100% { transform: translateX(120%) skewX(-16deg); opacity: 0; }
}
#homeRoot .horo-btn {
  position: relative;
  overflow: hidden;
}
#homeRoot .horo-btn::after {
  content: "";
  position: absolute;
  inset: -20% -40%;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.30) 45%, rgba(255,255,255,0) 100%);
  transform: translateX(-120%) skewX(-16deg);
  opacity: 0;
  pointer-events: none;
  animation: horoBtnSheen 5.2s ease-in-out infinite;
}

/* Reduced motion: disable animations */
@media (prefers-reduced-motion: reduce) {
  #homeRoot .horo-card:hover { transform: none !important; }
  #homeRoot .horo-card .horo-ring,
  #homeRoot .horo-card .horo-shine,
  #homeRoot .horo-card .horo-orb,
  #homeRoot .horo-stars,
  #homeRoot .horo-title,
  #homeRoot .horo-btn::after {
    animation: none !important;
  }
  #homeRoot .horo-card .horo-shine { opacity: 0 !important; }
}

#homeRoot .horo-card::before {
  content: "";
  position: absolute;
  inset: -10px;
  border-radius: 22px;
  pointer-events: none;
  z-index: -1;
  background:
    radial-gradient(70% 90% at 20% 45%, rgba(255,215,0,0.42), rgba(255,215,0,0) 68%),
    radial-gradient(70% 90% at 80% 45%, rgba(218,165,32,0.36), rgba(218,165,32,0) 68%),
    radial-gradient(90% 110% at 50% 60%, rgba(106,13,173,0.20), rgba(106,13,173,0) 70%);
  filter: blur(10px);
  opacity: 0.92;
}
  #homeRoot .horo-card {
  max-width: 420px;
  padding: 6px 8px;
}

/* Header button (always visible) */
#homeRoot .horo-mini {
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 6px;
  border: none;
  background: transparent;
  color: inherit;
  cursor: default;
  text-align: left;
  font: inherit;
  flex-wrap: nowrap;
  min-width: 0;
  overflow: visible;
  border-radius: 10px;
  transition: background .12s ease, transform .12s ease;
  -webkit-tap-highlight-color: transparent;
}
  #homeRoot .horo-mini:active {
  transform: scale(0.995);
}

#homeRoot .horo-mini:focus-visible {
  outline: 3px solid rgba(218,165,32,0.55);
  outline-offset: 3px;
  border-radius: 14px;
}

#homeRoot .horo-mini-right {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex: 0 0 auto;
  justify-content: flex-end;
  min-width: 0;
  flex-wrap: nowrap;
}

@media (max-width: 480px) {
  #homeRoot .horo-mini-right {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}
}

/* ✅ Prevent inner pieces from forcing overflow */
#homeRoot .horo-title {
  min-width: 0;
}
#homeRoot .horo-title span:last-child {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#homeRoot .horo-chip {
  max-width: 38vw;
  min-width: 0;
}
#homeRoot .horo-chip span:last-child {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#homeRoot .horo-mini-meta {
  max-width: 28vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
  #homeRoot .horo-chevron {
  flex: 0 0 auto;
  margin-left: auto;
}

/* Slightly tighter on small screens */
@media (max-width: 420px) {
  #homeRoot .horo-mini { padding: 6px 6px; gap: 6px; }
  #homeRoot .horo-mini-right { gap: 6px; }
  #homeRoot .horo-chip { max-width: 56vw; }
  #homeRoot .horo-mini-meta { max-width: 40vw; }
  #homeRoot .horo-body { font-size: 11.8px; line-height: 1.38; }
}

/* Ultra small: keep layout stable by shrinking date meta */
@media (max-width: 360px) {
  #homeRoot .horo-mini-meta { max-width: 32vw; }
}

#homeRoot .horo-mini-meta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 999px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.08);
  color: rgba(255,233,166,0.90);
  font-weight: 800;
  font-size: 9px;
}

#homeRoot .horo-chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: rgba(255,215,0,0.05);
  border: 1px solid rgba(218,165,32,0.16);
  color: rgba(255,215,0,0.72);
  font-weight: 900;
  font-size: 8px;
  transition: transform .12s ease;
}

#homeRoot .horo-dot { opacity: .85; }

/* Details accordion */
#homeRoot .horo-details {
  position: relative;
  z-index: 2;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transform: translateY(-2px);
  transition: max-height 140ms cubic-bezier(.2,.8,.2,1), opacity 100ms ease, transform 120ms ease;
  will-change: max-height, opacity, transform;
  padding: 0 6px;
}

#homeRoot .horo-details[data-open="1"] {
  max-height: 1200px;
  opacity: 1;
  transform: translateY(0);
  padding: 2px 6px 12px;
}

@media (prefers-reduced-motion: reduce) {
  #homeRoot .horo-details { transition: none; }
}

/* Make FX calmer when collapsed */
#homeRoot .horo-card.is-closed .horo-ring { opacity: .35; }
#homeRoot .horo-card.is-closed .horo-orb { opacity: .22; }
#homeRoot .horo-card.is-closed .horo-stars { opacity: .38; }
#homeRoot .horo-card.is-closed .horo-shine { opacity: 0; }

/* Micro-compact typography */
#homeRoot .horo-title {
  font-size: 10.5px;
}
#homeRoot .horo-chip {
  font-size: 8.8px;
  padding: 3px 6px;
}
#homeRoot .horo-body {
  font-size: 11.2px;
  letter-spacing: .08px;
}
#homeRoot .horo-footer { margin-top: 9px; }
#homeRoot .horo-meta { font-size: 9.5px; }

@keyframes horoStarFloat {
  0% { transform: translateY(0) translateX(0); opacity: .55; }
  50% { transform: translateY(-6px) translateX(2px); opacity: .85; }
  100% { transform: translateY(0) translateX(0); opacity: .55; }
}

#homeRoot .horo-stars {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  opacity: .34;
  background-image:
    radial-gradient(circle at 20% 25%, rgba(255,215,0,0.85) 0 1px, rgba(255,215,0,0) 2px),
    radial-gradient(circle at 60% 18%, rgba(255,255,255,0.75) 0 1px, rgba(255,255,255,0) 2px),
    radial-gradient(circle at 82% 30%, rgba(255,215,0,0.70) 0 1px, rgba(255,215,0,0) 2px),
    radial-gradient(circle at 32% 70%, rgba(255,255,255,0.60) 0 1px, rgba(255,255,255,0) 2px),
    radial-gradient(circle at 74% 78%, rgba(255,215,0,0.65) 0 1px, rgba(255,215,0,0) 2px);
  animation: horoStarFloat 2.4s ease-in-out infinite;
}

#homeRoot .horo-head {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

#homeRoot .horo-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: "Cinzel Decorative", "Cinzel", serif;
  font-weight: 900;
  letter-spacing: .24px;
  color: #FFD700;
  font-size: 10.5px;
  text-shadow: 0 1px 8px rgba(0,0,0,0.28);
}

#homeRoot .horo-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 6px;
  border-radius: 999px;
  background: rgba(255,215,0,0.06);
  border: 1px solid rgba(218,165,32,0.20);
  color: #FFE9A6;
  font-weight: 800;
  font-size: 8.8px;
  text-transform: capitalize;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
}

#homeRoot .horo-body {
  position: relative;
  z-index: 1;
  text-align: left;
  padding: 6px 7px;
  border-radius: 8px;
  background: rgba(255,255,255,0.035);
  border: 1px solid rgba(255,255,255,0.045);
  box-shadow: inset 0 0 0 1px rgba(0,0,0,0.035);
  font-family: "Cormorant Garamond", "Cinzel", serif;
  font-weight: 700;
  font-size: 11.2px;
  line-height: 1.32;
  color: #FFF3C6;
}

#homeRoot .horo-body-premium {
  padding: 7px 8px;
}
  #homeRoot .horo-body-premium {
  padding: 8px 9px 9px;
}

#homeRoot .horo-reading-premium {
  display: grid;
  gap: 8px;
}
  #homeRoot .horo-reading-premium {
  display: grid;
  gap: 6px;
  padding-bottom: 6px;
}

#homeRoot .horo-energy-headline {
  display: grid;
  gap: 2px;
  padding: 0;
}

#homeRoot .horo-energy-kicker {
  display: inline-flex;
  width: fit-content;
  color: #FFD700;
  font-family: "Cinzel", serif;
  font-size: 9.8px;
  font-weight: 950;
  letter-spacing: 0.28px;
  text-transform: uppercase;
  text-shadow: 0 0 12px rgba(255,215,0,0.22);
}

#homeRoot .horo-main-message {
  margin: 0;
  color: #FFF7D1;
  font-size: 12.2px;
  line-height: 1.22;
  font-weight: 900;
}

#homeRoot .horo-vibe-meter {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 5px;
  padding: 4px 7px;
  border-radius: 999px;
  background: linear-gradient(135deg, rgba(255,215,0,0.12), rgba(75,0,130,0.18));
  border: 1px solid rgba(218,165,32,0.20);
}

#homeRoot .horo-vibe-label,
#homeRoot .horo-vibe-value {
  color: #FFE8A3;
  font-size: 9.7px;
  font-weight: 950;
  white-space: nowrap;
}

#homeRoot .horo-vibe-track {
  height: 5px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(255,255,255,0.13);
}

#homeRoot .horo-vibe-fill {
  display: block;
  width: 82%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #DAA520, #FFD700, #FFF1A8);
  box-shadow: 0 0 10px rgba(255,215,0,0.35);
}

#homeRoot .horo-premium-stack {
  display: grid;
  gap: 7px;
}

#homeRoot .horo-premium-block {
  display: grid;
  gap: 3px;
  padding: 7px 8px;
  border-radius: 11px;
  background:
    radial-gradient(120% 150% at 0% 0%, rgba(255,215,0,0.08), rgba(255,215,0,0.00) 44%),
    linear-gradient(135deg, rgba(75,0,130,0.24), rgba(218,165,32,0.075));
  border: 1px solid rgba(218,165,32,0.18);
  box-shadow: 0 8px 18px rgba(0,0,0,0.10), inset 0 0 0 1px rgba(255,255,255,0.035);
}

#homeRoot .horo-premium-label {
  color: #FFD700;
  font-family: "Cinzel", serif;
  font-size: 9.8px;
  font-weight: 950;
}

#homeRoot .horo-premium-text {
  color: rgba(255,243,198,0.96);
  font-size: 11.5px;
  line-height: 1.30;
  font-weight: 800;
}

#homeRoot .horo-remember-block {
  background:
    radial-gradient(120% 150% at 0% 0%, rgba(255,255,255,0.10), rgba(255,255,255,0.00) 45%),
    linear-gradient(135deg, rgba(218,165,32,0.14), rgba(75,0,130,0.20));
  border-color: rgba(255,215,0,0.24);
}

#homeRoot .horo-reading {
  display: grid;
  gap: 7px;
}

#homeRoot .horo-main-message {
  margin: 0;
  color: #FFF7D1;
  font-size: 12.4px;
  line-height: 1.34;
  font-weight: 900;
}

#homeRoot .horo-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
}

#homeRoot .horo-mini-block {
  display: grid;
  gap: 2px;
  padding: 6px 7px;
  border-radius: 9px;
  background: linear-gradient(135deg, rgba(75,0,130,0.22), rgba(218,165,32,0.08));
  border: 1px solid rgba(218,165,32,0.18);
}

#homeRoot .horo-mini-block-label {
  color: #FFD700;
  font-family: "Cinzel", serif;
  font-size: 9.5px;
  font-weight: 950;
}

#homeRoot .horo-mini-block-text {
  color: rgba(255,243,198,0.94);
  font-size: 11.2px;
  line-height: 1.28;
  font-weight: 800;
}

@media (min-width: 420px) {
  #homeRoot .horo-grid {
    grid-template-columns: 1fr 1fr;
  }

  #homeRoot .horo-mini-block-full {
    grid-column: 1 / -1;
  }
}

#homeRoot .horo-footer {
  position: relative;
  z-index: 1;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

#homeRoot .horo-meta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 900;
  font-size: 10px;
  color: rgba(255,233,166,0.92);
  flex: 1 1 160px;
  min-width: 0;
  flex-wrap: wrap;
}

#homeRoot .horo-btn {
  border: none;
  border-radius: 11px;
  padding: 9px 12px;
  font-weight: 900;
  font-size: 11px;
  cursor: pointer;
  color: #2a004b;
  background: linear-gradient(135deg, #DAA520, #FFD700);
  box-shadow: 0 12px 22px rgba(218,165,32,0.28), 0 0 0 1px rgba(255,255,255,0.10) inset;
  transition: transform .16s ease, filter .18s ease, box-shadow .18s ease;
  white-space: nowrap;
  flex: 0 1 auto;
  max-width: 100%;
}

#homeRoot .horo-btn:disabled {
  cursor: default;
  opacity: .92;
  filter: saturate(.85) brightness(.95);
}

@media (hover: hover) {
  #homeRoot .horo-btn:hover {
    transform: translateY(-1px);
    filter: brightness(1.04) saturate(1.05);
    box-shadow: 0 16px 28px rgba(218,165,32,0.33), 0 0 18px rgba(255,215,0,0.16);
  }
}

#homeRoot .horo-claimed {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 11px;
  background: rgba(75,0,130,0.22);
  border: 1px solid rgba(218,165,32,0.30);
  color: rgba(255,215,0,0.78);
  font-weight: 900;
  font-size: 10px;
  flex: 0 1 auto;
  max-width: 100%;
  white-space: nowrap;
}

@media (max-width: 420px) {
  #homeRoot .horo-footer {
    align-items: stretch;
    gap: 8px;
  }

  #homeRoot .horo-meta {
    flex-basis: 100%;
    justify-content: flex-start;
  }

  #homeRoot .horo-btn,
  #homeRoot .horo-claimed {
    width: 100%;
    justify-content: center;
  }
}

@media (prefers-reduced-motion: reduce) {
  #homeRoot .horo-stars { animation: none !important; opacity: .45; }
  #homeRoot .horo-btn { transition: none !important; }
}

/* === Nombre de usuario dentro de la píldora: permite salto de línea sin "..." === */
#homeRoot .welcome-card .user-name {
  display: block;
  white-space: normal;        /* permite 2 líneas si es necesario */
  overflow: visible;          /* no recorta el texto interno */
  text-overflow: clip;        /* sin "..." al final */
  max-width: 100%;            /* puede ocupar todo el ancho de la píldora */
  line-height: 1.1;
  word-break: keep-all;
  overflow-wrap: break-word;  /* por si algún nombre muy largo lo necesita */
}

/* El contenedor h1 no fuerza toda la fila en una sola línea */
#homeRoot .welcome-card h1 {
  white-space: normal;
  word-break: normal;
  overflow-wrap: normal;
  max-width: 100%;
  font-size: clamp(0.9rem, 3.6vw, 1.55rem);
  line-height: 1.1;
}

/* La card puede encogerse bien en mobile sin recortar el contenido interno */
#homeRoot .welcome-card {
  min-width: 0;
}

  /* === Aura dorada animada para la píldora y el avatar === */
@keyframes goldAuraPulse {
  0%   { opacity: .55; filter: blur(7px) saturate(1.02); }
  50%  { opacity: .95; filter: blur(10px) saturate(1.08); }
  100% { opacity: .55; filter: blur(7px) saturate(1.02); }
}
@keyframes avatarHalo {
  0%   { transform: scale(1);   opacity: .45; }
  50%  { transform: scale(1.06); opacity: .85; }
  100% { transform: scale(1);   opacity: .45; }
}

/* Contenedor de nombre + foto (píldora) con aura */
#homeRoot .welcome-pill {
  position: relative;
  isolation: isolate; /* asegura que el ::before no fugue */
  box-shadow:
    0 0 8px rgba(255,215,0,0.55),
    0 0 18px rgba(255,215,0,0.35),
    inset 0 0 12px rgba(255,215,0,0.22);
  transition: filter .25s ease, box-shadow .25s ease, transform .2s ease;
}

/* Capa de aura externa */
#homeRoot .welcome-pill::before {
  content: "";
  position: absolute;
  inset: -4px;
  border-radius: 18px; /* acompaña a borderRadius:20px del inline */
  background:
    radial-gradient(60% 60% at 20% 50%, rgba(255,215,0,0.65), rgba(255,215,0,0) 70%),
    radial-gradient(70% 70% at 80% 50%, rgba(218,165,32,0.55), rgba(255,215,0,0) 75%);
  z-index: -1;
  pointer-events: none;
  animation: goldAuraPulse 1.8s ease-in-out infinite;
}

/* Intensidad 3 (notorio) */
#homeRoot .welcome-pill.aura-strong::before {
  opacity: .95;
  animation-duration: 1.6s;
  filter: saturate(1.12);
}

#homeRoot .welcome-pill:hover {
  filter: brightness(1.05) saturate(1.06);
  transform: translateY(-1px);
}

/* Halo del avatar */
#homeRoot .avatar-aura {
  position: relative;
  box-shadow: 0 0 10px rgba(218,165,32,0.6), 0 0 26px rgba(218,165,32,0.35);
}
#homeRoot .avatar-aura::after {
  content: "";
  position: absolute;
  inset: -7px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,215,0,0.55) 0%, rgba(255,215,0,0.18) 45%, rgba(255,215,0,0) 70%);
  animation: avatarHalo 1.6s ease-in-out infinite;
  pointer-events: none;
  z-index: -1;
}

html,
body,
#root {
  width: 100%;
  min-height: 100%;
  height: 100%;
  margin: 0;
  background: #1A0039 !important;
  background-color: #1A0039 !important;
  overflow-x: hidden;
}

/* Home cubre el viewport, pero deja visible la capa violeta/dorada propia del Home */
#homeRoot {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100dvh;
  min-height: 100dvh;
  max-height: 100dvh;
  background: transparent !important;
  background-color: transparent !important;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: auto;
  box-sizing: border-box;
}

/* Extiende el mismo fondo del Home debajo del safe-area, sin negro ni violeta plano */
#homeRoot::after {
  content: "";
  position: fixed;
  left: 0;
  right: 0;
  bottom: -180px;
  height: calc(220px + env(safe-area-inset-bottom, 0px));
  pointer-events: none;
  z-index: -5;
  background:
    radial-gradient(circle at 50% 0%, rgba(155,48,255,0.10) 0%, rgba(155,48,255,0.00) 58%),
    linear-gradient(180deg, #1A0039 0%, #1A0039 100%);
}

@supports (-webkit-touch-callout: none) {
  html,
  body,
  #root {
    height: 100%;
    min-height: 100%;
    background: #1A0039 !important;
    background-color: #1A0039 !important;
  }

  #homeRoot {
    height: 100dvh !important;
    min-height: 100dvh !important;
    max-height: 100dvh !important;
    background: transparent !important;
    background-color: transparent !important;
  }
}

@media (display-mode: standalone) {
  html,
  body,
  #root {
    background: #1A0039 !important;
    background-color: #1A0039 !important;
  }

  #homeRoot {
    height: 100dvh !important;
    min-height: 100dvh !important;
    max-height: 100dvh !important;
    background: transparent !important;
    background-color: transparent !important;
  }
}

@media (max-width: 480px) {
  #homeRoot {
    padding-bottom: 0 !important;
  }
}

/* Más intensidad cuando el contenedor es fuerte */
#homeRoot .welcome-pill.aura-strong .avatar-aura::after {
  animation-duration: 1.2s;
  opacity: .95;
}

@media (prefers-reduced-motion: reduce) {
  #homeRoot .welcome-pill::before,
  #homeRoot .avatar-aura::after {
    animation: none !important;
    opacity: .65;
  }
}
#homeRoot .horo-cosmic-state {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 5px 7px;
  border-radius: 9px;
}
  margin-top: 8px;

  background:
    radial-gradient(circle at top left,
      rgba(255,215,0,0.12),
      transparent 60%),
    linear-gradient(
      135deg,
      rgba(75,0,130,0.26),
      rgba(218,165,32,0.08)
    );

  border: 1px solid rgba(218,165,32,0.18);
}

#homeRoot .horo-cosmic-icon {
  flex-shrink: 0;
  font-size: 22px;
  line-height: 1;
  margin-top: 2px;
}

#homeRoot .horo-cosmic-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

#homeRoot .horo-cosmic-label {
  display: block;
  color: #FFD700;
  font-family: "Cinzel", serif;
  font-size: 9px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: .4px;
}

#homeRoot .horo-cosmic-text {
  display: block;
  color: #FFF3C6;
  font-size: 11px;
  line-height: 1.18;
  font-weight: 800;
  white-space: normal;
  word-break: break-word;
}

  display: flex;
  align-items: flex-start;
  gap: 10px;

  padding: 10px;
  border-radius: 12px;
  margin-top: 8px;

  background:
    radial-gradient(circle at top left,
      rgba(255,215,0,0.12),
      transparent 60%),
    linear-gradient(
      135deg,
      rgba(75,0,130,0.26),
      rgba(218,165,32,0.08)
    );

  border: 1px solid rgba(218,165,32,0.18);
}

#homeRoot .horo-cosmic-icon {
  flex-shrink: 0;
  font-size: 22px;
  line-height: 1;
  margin-top: 2px;
}

#homeRoot .horo-cosmic-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

#homeRoot .horo-cosmic-label {
  display: block;
  color: #FFD700;
  font-family: "Cinzel", serif;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: .4px;
}

#homeRoot .horo-cosmic-text {
  display: block;
  color: #FFF3C6;
  font-size: 11.5px;
  line-height: 1.45;
  font-weight: 700;

  white-space: normal;
  word-break: break-word;
}
  #homeRoot .horo-premium-stack {
  display: grid;
  gap: 10px;
}

#homeRoot .horo-premium-block {
  overflow: visible;
}

#homeRoot .horo-details {
  overflow: visible;
}

/* === Trivia V2.2: compact monthly competition hierarchy === */
#homeRoot .trivia-modal .trivia-season-header {
  display: grid;
  gap: 3px;
  max-width: 520px;
  margin: 14px auto 12px;
  color: #31114f;
  font-size: 17px;
  font-weight: 900;
  letter-spacing: -0.18px;
}

#homeRoot .trivia-modal .trivia-season-header::after {
  content: '';
  width: 28px;
  height: 2px;
  margin: 5px auto 0;
  border-radius: 999px;
  background: rgba(218,165,32,.72);
}

#homeRoot .trivia-modal .trivia-season-header.is-daily::after { background: rgba(75,0,130,.36); }

#homeRoot .trivia-period-control,
#homeRoot .trivia-scope-control {
  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  border-radius: 12px;
  padding: 3px;
  background: rgba(75,0,130,.055);
  border: 1px solid rgba(75,0,130,.11);
}

#homeRoot .trivia-period-control { margin-bottom: 9px; }
#homeRoot .trivia-scope-control {
  margin-bottom: 12px;
  background: rgba(49,17,79,.70);
  border-color: rgba(218,165,32,.30);
  box-shadow: inset 0 1px 0 rgba(255,255,255,.12), 0 3px 10px rgba(46,10,75,.10);
}

#homeRoot .trivia-period-control button,
#homeRoot .trivia-scope-control button {
  min-height: 44px;
  min-width: 86px;
  padding: 0 14px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: rgba(49,17,79,.64);
  cursor: pointer;
  font-size: 13px;
  font-weight: 800;
  transition: background .16s ease, color .16s ease, box-shadow .16s ease;
}

#homeRoot .trivia-period-control button.is-selected {
  background: rgba(255,255,255,.9);
  color: #3a135a;
  box-shadow: 0 2px 8px rgba(46,10,75,.12), inset 0 -2px 0 rgba(218,165,32,.74);
}

#homeRoot .trivia-scope-control button {
  min-height: 40px;
  min-width: 100px;
  font-size: 12px;
  color: rgba(255,255,255,.84);
  letter-spacing: .005em;
}
#homeRoot .trivia-scope-control button:hover,
#homeRoot .trivia-scope-control button:active {
  color: #fff;
  background: rgba(255,255,255,.10);
}
#homeRoot .trivia-scope-control button.is-selected {
  color: #fff;
  background: rgba(218,165,32,.28);
  box-shadow: inset 0 0 0 1px rgba(255,223,137,.62), 0 2px 6px rgba(23,7,41,.20);
}

#homeRoot .trivia-period-control button:focus-visible,
#homeRoot .trivia-scope-control button:focus-visible {
  outline: 3px solid rgba(218,165,32,.72);
  outline-offset: 2px;
}

#homeRoot .trivia-leaderboard-content {
  width: min(100%, 520px);
  margin: 0 auto;
}

#homeRoot .trivia-top-three {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: end;
  gap: 8px;
  margin: 4px 0 14px;
}

#homeRoot .trivia-top-card {
  display: grid;
  justify-items: center;
  align-content: start;
  gap: 4px;
  min-width: 0;
  padding: 10px 7px 9px;
  border-radius: 12px;
  background: rgba(75,0,130,.045);
  color: #32124d;
}

#homeRoot .trivia-top-card.place-1 {
  order: 2;
  padding-top: 7px;
  background: rgba(218,165,32,.12);
  box-shadow: inset 0 2px 0 rgba(218,165,32,.62);
}
#homeRoot .trivia-top-card.place-2 { order: 1; }
#homeRoot .trivia-top-card.place-3 { order: 3; }

#homeRoot .trivia-top-rank,
#homeRoot .trivia-row-rank,
#homeRoot .trivia-my-rank,
#homeRoot .trivia-my-points,
#homeRoot .trivia-row-points,
#homeRoot .trivia-top-points {
  font-variant-numeric: tabular-nums;
}

#homeRoot .trivia-top-rank { color: rgba(75,0,130,.68); font-size: 12px; font-weight: 900; }
#homeRoot .trivia-top-card.place-1 .trivia-top-rank { color: #8b6510; }

#homeRoot .trivia-leaderboard-avatar {
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(75,0,130,.16);
  background: rgba(75,0,130,.1);
}
#homeRoot .trivia-leaderboard-avatar.is-top-avatar { width: 42px; height: 42px; }
#homeRoot .trivia-top-card.place-1 .trivia-leaderboard-avatar.is-top-avatar { width: 52px; height: 52px; border-color: rgba(218,165,32,.64); }

#homeRoot .trivia-top-name {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 800;
}
#homeRoot .trivia-top-card.place-1 .trivia-top-name { font-size: 13px; }
#homeRoot .trivia-top-sign { min-height: 14px; font-size: 13px; }
#homeRoot .trivia-top-points { color: #6e4b05; font-size: 12px; font-weight: 900; white-space: nowrap; }

#homeRoot .trivia-leaderboard-list {
  display: grid;
  gap: 1px;
  border-top: 1px solid rgba(75,0,130,.09);
  border-bottom: 1px solid rgba(75,0,130,.09);
}

#homeRoot .trivia-leaderboard-row {
  display: grid;
  grid-template-columns: minmax(34px, max-content) minmax(0, 1fr) max-content minmax(38px, max-content);
  align-items: center;
  min-height: 52px;
  gap: 8px;
  padding: 0 8px;
  color: #32124d;
  border-bottom: 1px solid rgba(75,0,130,.065);
}
#homeRoot .trivia-leaderboard-row:last-child { border-bottom: 0; }
#homeRoot .trivia-leaderboard-row.is-daily { grid-template-columns: minmax(34px, max-content) minmax(0, 1fr) max-content; }
#homeRoot .trivia-leaderboard-row.is-current-user { background: rgba(218,165,32,.105); box-shadow: inset 2px 0 0 rgba(218,165,32,.76); }

#homeRoot .trivia-row-rank { color: rgba(75,0,130,.64); font-size: 12px; font-weight: 900; text-align: right; }
#homeRoot .trivia-row-identity { display: flex; align-items: center; min-width: 0; gap: 8px; }
#homeRoot .trivia-row-name { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 13px; font-weight: 750; }
#homeRoot .trivia-row-sign { flex: 0 0 auto; font-size: 13px; }
#homeRoot .trivia-row-points { color: #5c3a00; font-size: 12px; white-space: nowrap; text-align: right; }
#homeRoot .trivia-row-accuracy { color: rgba(49,17,79,.56); font-size: 11px; font-weight: 700; text-align: right; }

#homeRoot .trivia-my-position {
  display: grid;
  gap: 7px;
  margin: 15px auto 2px;
  padding: 11px 13px;
  max-width: 360px;
  border-radius: 12px;
  color: #32124d;
  background: rgba(75,0,130,.055);
  box-shadow: inset 2px 0 0 rgba(218,165,32,.68);
}
#homeRoot .trivia-section-label { color: rgba(49,17,79,.62); font-size: 11px; font-weight: 900; letter-spacing: .05em; text-transform: uppercase; }
#homeRoot .trivia-my-position-primary { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; }
#homeRoot .trivia-my-rank { font-size: 24px; line-height: 1; }
#homeRoot .trivia-my-points { color: #5c3a00; font-size: 15px; }
#homeRoot .trivia-my-position-secondary { display: flex; gap: 10px; color: rgba(49,17,79,.62); font-size: 12px; font-weight: 700; }

#homeRoot .trivia-leaderboard-state {
  width: min(100%, 360px);
  min-height: 96px;
  display: grid;
  place-content: center;
  gap: 8px;
  margin: 4px auto;
  padding: 12px;
  color: rgba(49,17,79,.67);
  font-size: 13px;
  text-align: center;
}
#homeRoot .trivia-leaderboard-state.is-loading { min-height: 150px; color: rgba(75,0,130,.72); }
#homeRoot .trivia-leaderboard-state.is-error { color: rgba(75,0,130,.72); }

@media (max-width: 340px) {
  #homeRoot .trivia-top-three { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  #homeRoot .trivia-top-card.place-1 { grid-column: 1 / -1; }
  #homeRoot .trivia-top-card { padding-inline: 5px; }
  #homeRoot .trivia-leaderboard-row { grid-template-columns: minmax(30px, max-content) minmax(0, 1fr) max-content minmax(34px, max-content); gap: 5px; padding-inline: 4px; }
  #homeRoot .trivia-row-sign { display: none; }
}

@media (max-width: 380px) {
  /* Three ranking scopes fit inside the existing mobile modal without
     changing the two-scope layout or increasing the modal height. */
  #homeRoot .trivia-scope-control.has-country {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
    box-sizing: border-box;
  }
  #homeRoot .trivia-scope-control.has-country button {
    min-width: 0;
    padding-inline: 8px;
  }
}

@media (min-width: 640px) {
  #homeRoot .trivia-leaderboard-content { max-width: 500px; }
  #homeRoot .trivia-top-three { max-width: 460px; margin-inline: auto; }
}

@media (prefers-reduced-motion: reduce) {
  #homeRoot .trivia-period-control button,
  #homeRoot .trivia-scope-control button { transition: none; }
}

/* === Trivia V2.3: completed-day flow and daily game hierarchy === */
#homeRoot .trivia-season-scope {
  color: rgba(49,17,79,.64);
  font-size: 12px;
  font-weight: 750;
}

#homeRoot .trivia-played-summary,
#homeRoot .trivia-result-summary {
  display: grid;
  justify-items: center;
  gap: 10px;
  max-width: 390px;
  margin: 4px auto;
  padding: 16px 4px 8px;
  text-align: center;
  color: #32124d;
}
#homeRoot .trivia-played-summary h2,
#homeRoot .trivia-result-title {
  margin: 0;
  font-size: 20px;
  line-height: 1.2;
  font-weight: 900;
}
#homeRoot .trivia-played-summary p {
  max-width: 330px;
  margin: 0;
  color: rgba(49,17,79,.67);
  font-size: 13px;
  line-height: 1.45;
}
#homeRoot .trivia-played-stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: min(100%, 330px);
  gap: 1px;
  overflow: hidden;
  border: 1px solid rgba(75,0,130,.1);
  border-radius: 12px;
  background: rgba(75,0,130,.045);
}
#homeRoot .trivia-played-stats > div {
  display: grid;
  gap: 3px;
  min-width: 0;
  padding: 10px;
}
#homeRoot .trivia-played-stats > div + div { border-left: 1px solid rgba(75,0,130,.09); }
#homeRoot .trivia-played-stats span { color: rgba(49,17,79,.59); font-size: 11px; font-weight: 750; }
#homeRoot .trivia-played-stats strong { font-size: 15px; font-variant-numeric: tabular-nums; }
#homeRoot .trivia-no-rank { color: rgba(49,17,79,.62); font-size: 12px; font-weight: 750; }
#homeRoot .trivia-summary-actions,
#homeRoot .trivia-feedback-actions { display: flex; justify-content: center; flex-wrap: wrap; gap: 8px; }
#homeRoot .trivia-primary-action,
#homeRoot .trivia-secondary-action,
#homeRoot .trivia-leaderboard-back {
  min-height: 44px;
  padding: 0 14px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 850;
  cursor: pointer;
  transition: transform .16s ease, background .16s ease, border-color .16s ease;
}
#homeRoot .trivia-primary-action {
  border: 1px solid rgba(218,165,32,.65);
  color: #3a135a;
  background: rgba(218,165,32,.18);
}
#homeRoot .trivia-secondary-action,
#homeRoot .trivia-leaderboard-back {
  border: 1px solid rgba(75,0,130,.16);
  color: rgba(49,17,79,.78);
  background: transparent;
}
#homeRoot .trivia-primary-action:hover,
#homeRoot .trivia-secondary-action:hover,
#homeRoot .trivia-leaderboard-back:hover { transform: translateY(-1px); }
#homeRoot .trivia-leaderboard-view { display: grid; gap: 0; padding-top: 2px; }
#homeRoot .trivia-leaderboard-back { justify-self: start; min-height: 36px; margin-bottom: 8px; padding-inline: 10px; font-size: 12px; }

#homeRoot .trivia-game-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}
#homeRoot .trivia-question-progress { color: #4b1974; font-size: 13px; font-weight: 900; }
#homeRoot .trivia-score-chip { flex: 0 0 auto; color: #5c3a00; font-size: 12px; font-weight: 900; font-variant-numeric: tabular-nums; }
#homeRoot .trivia-timer { display: grid; grid-template-columns: 32px minmax(0, 1fr); align-items: center; gap: 9px; margin-bottom: 14px; color: #4b1974; }
#homeRoot .trivia-timer strong { display: grid; place-items: center; width: 32px; height: 32px; border: 1px solid rgba(75,0,130,.19); border-radius: 50%; font-size: 13px; font-variant-numeric: tabular-nums; }
#homeRoot .trivia-timer-track { height: 4px; overflow: hidden; border-radius: 99px; background: rgba(75,0,130,.1); }
#homeRoot .trivia-timer-track > div { height: 100%; border-radius: inherit; background: rgba(218,165,32,.84); transition: width .15s linear; }
#homeRoot .trivia-timer.is-urgent { color: #a63548; }
#homeRoot .trivia-timer.is-urgent .trivia-timer-track > div { background: rgba(192,57,76,.75); }
#homeRoot .trivia-question-card { max-width: 570px; margin: 0 auto 16px; color: #2c1c4e; font-size: clamp(18px, 4.8vw, 22px); font-weight: 850; line-height: 1.38; }
#homeRoot .trivia-answer-list { display: grid; gap: 8px; }
#homeRoot .trivia-answer { min-height: 48px; line-height: 1.36; }
#homeRoot .trivia-answer-feedback { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-top: 13px; color: rgba(49,17,79,.75); font-size: 13px; line-height: 1.4; }
#homeRoot .trivia-answer-feedback > div:first-child { min-width: 0; }
#homeRoot .trivia-answer-feedback strong { display: block; color: #a63548; margin-bottom: 2px; }
#homeRoot .trivia-select-answer { margin-top: 12px; color: rgba(49,17,79,.58); font-size: 12px; }
#homeRoot .trivia-result-summary { margin-top: 18px; padding-top: 14px; border-top: 1px solid rgba(75,0,130,.1); }
#homeRoot .trivia-result-score { color: rgba(49,17,79,.72); font-size: 14px; font-weight: 750; }
#homeRoot .trivia-result-streak { color: #4b1974; font-size: 13px; font-weight: 800; }

@media (max-width: 340px) {
  #homeRoot .trivia-answer-feedback { align-items: stretch; flex-direction: column; }
  #homeRoot .trivia-feedback-actions > button { flex: 1 1 auto; }
  #homeRoot .trivia-played-summary { padding-inline: 0; }
}

@media (prefers-reduced-motion: reduce) {
  #homeRoot .trivia-primary-action,
  #homeRoot .trivia-secondary-action,
  #homeRoot .trivia-leaderboard-back,
  #homeRoot .trivia-timer-track > div { transition: none; }
}

  `}</style>
);

export default HomeStyles;
